'use client';

import { Button } from '@module/mdrt-org/shared/components/button/button';
import { loginHandler } from '@module/mdrt-org/shared/utils/helpers/login-handler';
import { AuthProviderName } from '@shared/misc/next-auth/enum';
import { ButtonVariant } from '@shared/ui-components/button/buttonVariant';

import styles from './login-banner.module.scss';

type LoginBannerCmsContentProps = {
  createAccountLabel: string;
  loginAlertText: string;
  loginPrompt: string;
};
type LoginBannerProps = {
  cmsContent: LoginBannerCmsContentProps;
  locale: string;
};

export const LoginBanner = ({ cmsContent, locale }: LoginBannerProps) => {
  return (
    <div aria-label={cmsContent.loginAlertText} className={styles.banner}>
      <div className={styles['banner__message']}>{cmsContent.loginAlertText}</div>
      <div className={styles['banner__buttons']}>
        <Button
          className={styles['banner__button']}
          onClick={() => loginHandler({ authorizationParameters: { ui_locales: locale } })}
          variant={ButtonVariant.Secondary}
        >
          {cmsContent.loginPrompt}
        </Button>
        <Button
          className={styles['banner__button']}
          onClick={() =>
            loginHandler({
              authorizationParameters: { ui_locales: locale },
              provider: AuthProviderName.CreateAccount,
            })
          }
        >
          {cmsContent.createAccountLabel}
        </Button>
      </div>
    </div>
  );
};
